const DataJournal = [
    {
        description : 'Gravel doesn\'t sound like a glamorous hardscaping material. It\'s cheap, ubiquitous, and really, well, gravelly.',
        image : 'images/article-1.jpg',
        title : (<>Garden Envy: 10 Dramatic <br /> Drainage Ideas to Steal</>),
    },
    {
        description : 'With the holidays ahead, this week the Remodelista editors discovered easy organizing strategies at home.',
        image : 'images/article-2.jpg',
        title : (<>5 Quick Ways to Organize <br /> Your Home</>),
    },
    {
        description : 'When Lauren Snyder and Keith Burns renovated their istoric brownstone in brooklyn\'s Bedford-Stuyvents neighborhood',
        image : 'images/article-3.jpg',
        title : (<>A Modern Garden for a <br /> Historic Townhouse</>)
    }
]
export default DataJournal;